import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

class List extends Component {
  static propTypes = {
    users: PropTypes.array,
    roles: PropTypes.string,
  }

  render() {
    const { user, users, companies } = this.props;
    const role = _.get(user, 'profile.roles');
    const content = users.map((item, key) => {
      const { username, name, objectId, carrier, shipper, roles } = item;
      return (<TableRow key={key}>
        {role === 'super-admin' &&
        <TableRowColumn>{objectId}</TableRowColumn>
        }
        <TableRowColumn>{username}</TableRowColumn>
        <TableRowColumn>{name}</TableRowColumn>
        {_.includes(['super-admin'], role) &&
        <TableRowColumn>{_.get(carrier, 'name')}</TableRowColumn>
        }
        {_.includes(['super-admin', 'carrier-admin'], role) &&
        <TableHeaderColumn>{_.get(shipper, 'name')}</TableHeaderColumn>
        }
        <TableRowColumn>{roles}</TableRowColumn>
      </TableRow>);
    });

    return (
      <div>
        <Table>
          <TableHeader>
            <TableRow>
              {role === 'super-admin' &&
                <TableHeaderColumn>ID</TableHeaderColumn>
              }
              <TableHeaderColumn>Username</TableHeaderColumn>
              <TableHeaderColumn>Name</TableHeaderColumn>
              {_.includes(['super-admin'], role) &&
              <TableHeaderColumn>Carrier</TableHeaderColumn>
              }
              {_.includes(['super-admin', 'carrier-admin'], role) &&
              <TableHeaderColumn>Shipper</TableHeaderColumn>
              }
              <TableHeaderColumn>Role</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody>
            { content }
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default List;


// WEBPACK FOOTER //
// ./src/components/Users/List.js